<template>
    <li class="nav-item">
        <a class="nav-link" :href="href" target="_blank" role="button">
            <slot></slot>
        </a>
    </li>
</template>

<script>
export default {
    name: "NavItem",
    props: {
        href: {
            type: String,
            required: true,
            default: ""
        }
    }
}
</script>

<style lang="scss" scoped>
.nav-item {
    border: none;
    background-color: white !important;
    color: $primary-color !important;
    padding-left: 15px;
    padding-right: 15px;

    &:hover, &:hover > * {
            cursor: pointer;
            color: white !important;
            background-color: $primary-color !important;
            text-decoration: none
        }

    a {
        background-color: white;
        color: $primary-color !important;
        line-height: 24px;
        font-size: 14px;
        text-align: center;
        font-style: normal;
        font-weight: 700;
        text-transform: uppercase;

        height: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
}

@media (max-width: 991.98px) {
    .nav-item {
        padding: 0px;
    }
}

@media (max-width: 1199.98px) {
  .nav-link {
    font-size: 12px !important;
  }
}
</style>
